<template>
  <div class="q-wrap">
    <div class="q-row">
      <label class="q-label">Texto de la pregunta</label>
      <input class="q-input" :class="{ 'q-input--error': question.error }" type="text"
        placeholder="Escribe la pregunta aquí..." v-model="question.texto" />
      <p v-if="question.error" class="q-error-msg">Ingrese la pregunta.</p>
    </div>

    <div class="q-row">
      <label class="q-label">Descripción <span>(opcional)</span></label>
      <textarea class="q-input" type="text" placeholder="Describe lo que se espera en la respuesta..." v-model="question.descripcion" ></textarea>
    </div>

    <div class="q-row">
      <label class="q-label">Nota <span>(opcional)</span></label>
      <input class="q-input" type="text" placeholder="Escribe una nota corta o definición..." v-model="question.nota_para_registrante" />
    </div>

    <div class="q-options-header">
      <span class="q-label m-0">Opciones de respuesta</span>
      <button type="button" class="q-add-btn" @click="addOption">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></svg>
        Agregar
      </button>
      <p v-if="question.optionError" class="q-error-msg">Deben llenarse todas las opciones.</p>
      <p v-if="question.minimumError" class="q-error-msg">Debe haber al menos dos opciones.</p>
      <p v-if="question.maximumOptionError" class="q-error-msg">Maximo {{ maxOptions }} opciones.</p>
      <label class="q-check-row ml-auto">
        <input type="checkbox" v-model="question.obligatoria" />
        <span>Obligatoria</span>
      </label>
    </div>

    <div class="q-row">
      <div class="q-options-list">
        <div v-for="(option, index) in question.opciones" :key="index" class="q-option-row">
          <span class="q-option-prefix">{{ index + 1 }}.</span>
          <input class="q-input" :class="{ 'q-input--error': option === '' && question.optionError }"
            type="text" :placeholder="'Opcion ' + (index + 1)" v-model="question.opciones[index]" />
          <div style="display: flex; align-items: center; gap: 4px; margin-left: auto;" v-if="question.saltos">
            <span class="q-label" style="font-size: 0.6rem; margin-right: 2px;">Salto:</span>
            <select class="q-input q-input--select" v-model="question.saltos[index]" style="min-width: 140px; padding: 4px 8px; font-size: 0.75rem;">
              <option :value="undefined">Continuar normal</option>
              <option v-for="q in validJumpTargets" :key="q.id_pregunta" :value="q.numero_pregunta">
                Saltar a {{ q.numero_pregunta }}.- {{ q.texto.length > 25 ? q.texto.substring(0, 25) + '...' : q.texto }}
              </option>
            </select>
          </div>

          <button v-if="question.opciones.length > 2" type="button" class="q-remove-btn" @click="removeOption(index)">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
          </button>
        </div>
      </div>
    </div>

    <label class="q-check-row ml-6">
      <input type="checkbox" v-model="question.otro" />
      <span>Incluir opcion "Otro"</span>
    </label>
    <div v-if="question.otro" class="q-otro-type-row">
      <label class="q-label">Tipo de dato del campo "Otro"</label>
      <select class="q-input q-input--select" v-model="question.tipo_otro">
        <option value="texto">Texto</option>
        <option value="numero">Número</option>
        <option value="fecha">Fecha</option>
        <option value="hora">Hora</option>
      </select>
    </div>
    <div class="q-row" v-if="question.otro && question.saltos" style="margin-left: 20px; flex-direction: row; align-items: center; gap: 6px;">
      <span class="q-label" style="font-size: 0.6rem;">Salto:</span>
      <select class="q-input q-input--select" v-model="question.saltos['otro']" style="max-width: 200px; padding: 4px 8px; font-size: 0.75rem;">
        <option :value="undefined">Continuar normal</option>
        <option v-for="q in validJumpTargets" :key="q.id_pregunta" :value="q.numero_pregunta">
          Saltar a {{ q.numero_pregunta }}.- {{ q.texto.length > 25 ? q.texto.substring(0, 25) + '...' : q.texto }}
        </option>
      </select>
    </div>
    
    <div class="q-options-header mt-5">
      <span class="q-label m-0">Subpreguntas</span>
      <button type="button" class="q-add-btn" @click="addSubquestion('open')">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M4 9h16v2H4zm0 4h10v2H4z"/></svg>
        Abierta
      </button>
      <button type="button" class="q-add-btn" @click="addSubquestion('multiple')">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/></svg>
        Opcion
      </button>
      <button type="button" class="q-add-btn" @click="addSubquestion('fields')">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M7 20V7H2V4H15V7H10V20ZM16 20V12H13V9H22V12H19V20Z"/></svg>
        Campos
      </button>
      <p v-if="question.maximumSubquestionError" class="q-error-msg">Maximo {{ maxOptions }} subpreguntas.</p>
    </div>

    <div class="q-row pl-4 border-l mt-1 flex flex-colums gap-2">
      <div v-for="(subquestion, index) in question.subpregunta" :key="subquestion.numero_pregunta">
        <open-sub-question v-if="subquestion.tipo === 'ABIERTA'" @click="removeSubquestion(index)" :question="subquestion" :ref="'subquestion' + index" :parentType="question.tipo" :parentOptions="question.opciones"></open-sub-question>
        <multiple-sub-question v-if="subquestion.tipo === 'SELECCION'" @click="removeSubquestion(index)" :question="subquestion" :ref="'subquestion' + index" :parentType="question.tipo" :parentOptions="question.opciones"></multiple-sub-question>
        <fields-sub-question v-if="subquestion.tipo === 'CAMPOS'" @click="removeSubquestion(index)" :question="subquestion" :ref="'subquestion' + index" :parentType="question.tipo" :parentOptions="question.opciones"></fields-sub-question>
      </div>
    </div>
  </div>
</template>
<script>
import OpenSubQuestion from "./OpenSubQuestion";
import MultipleSubQuestion from "./MultipleSubQuestion";
import FieldsSubQuestion from "./FieldsSubQuestion";

export default {
  name: "multiple-question",
  components: {
    OpenSubQuestion,
    MultipleSubQuestion,
    FieldsSubQuestion,
  },
  data() {
    return { lastId: 1, maxOptions: 25 };
  },
  created() {
    if (!this.question.saltos) {
      this.$set(this.question, 'saltos', {});
    }
  },
   mounted() {
    this.fetchConfiguration();
    if (!this.question.tipo_otro) this.$set(this.question, 'tipo_otro', 'texto');
  },
  computed: {
    validJumpTargets() {
      if (!this.allQuestions || !this.allQuestions.length) return [];
      const myIndex = this.allQuestions.findIndex(q => q.id_pregunta === this.question.id_pregunta);
      if (myIndex === -1) return [];
      return this.allQuestions.slice(myIndex + 1);
    }
  },
  methods: {
    fetchConfiguration() {
      this.axios.get("apidev/api/config/site").then(response => {
        if (response.data && response.data.config && typeof response.data.config.max_question_options === "number") {
          this.maxOptions = response.data.config.max_question_options;
        }
      }).catch(() => {});
    },
    remove() { this.$emit("click"); },
    addSubquestion(type) {
      this.lastId = this.question.subpregunta.length? this.question.subpregunta.length + 1 : 1;
      if (this.question.subpregunta.length < this.maxOptions) {
        let base = { numero_pregunta: this.question.numero_pregunta + "." + this.lastId, error: false };
        if (type === "open") {
          this.question.subpregunta.push({ ...base, tipo: "ABIERTA", texto: "", nota_para_registrante: "" });
        } else if (type === "multiple") {
          this.question.subpregunta.push({ ...base, tipo: "SELECCION", texto: "", nota_para_registrante: "", opciones: ["", ""], otro: false, optionError: false, minimumError: false, maximumOptionError: false });
        } else if (type === "fields") {
          this.question.subpregunta.push({ ...base, tipo: "CAMPOS", texto: "", nota_para_registrante: "", campos: [{ texto: "", tipo: "texto" }], fieldError: false, minimumError: false });
        }

      } else { this.question.maximumSubquestionError = true; }
    },
    removeSubquestion(index) {
      this.question.subpregunta.splice(index, 1);
      this.question.subpregunta.forEach((sub, i) => { sub.numero_pregunta = this.question.numero_pregunta + "." + (i + 1); });
      this.lastId = this.question.subpregunta.length + 1;
      this.question.maximumSubquestionError = false;
    },
    addOption() {
      if (this.question.opciones.length < this.maxOptions) {
        this.question.opciones.push("");
        this.question.minimumError = false;
      } else { this.question.maximumOptionError = true; }
    },
    removeOption(index) {
      if (this.question.opciones.length > 2) {
        this.question.opciones.splice(index, 1);
        this.question.maximumOptionError = false;
      } else { this.question.minimumError = true; }
    },
    validateQuestion() {
      let valid = true;
      if (this.question.texto === "") { this.question.error = true; valid = false; } else { this.question.error = false; }
      const empty = this.question.opciones.some(o => o === "");
      if (empty) { this.question.optionError = true; valid = false; } else { this.question.optionError = false; }
      if (this.question.opciones.length < 2) { this.question.minimumError = true; valid = false; } else { this.question.minimumError = false; }
      
      // Validate subquestions
      if (this.question.subpregunta.length > 0) {
        Object.keys(this.$refs).forEach((el) => {
          if (this.$refs[el] && this.$refs[el][0]) {
            if (!this.$refs[el][0].validateQuestion()) valid = false;
          }
        });
      }
      return valid;
    },
  },
  props: { question: { required: true }, allQuestions: { required: false, type: Array, default: () => [] } },
};
</script>
<style scoped>
.q-wrap { display: flex; flex-direction: column; gap: 12px; font-size: 0.82rem; }
.q-row { display: flex; flex-direction: column; gap: 4px; }
.q-label { font-size: 0.68rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.07em; color: #64748b; }
.q-input { width: 100%; padding: 6px 10px; border: 1px solid #cbd5e1; border-radius: 7px; background: #f8fafc; color: #334155; font-size: 0.82rem; transition: border-color 0.15s, box-shadow 0.15s; outline: none; box-sizing: border-box; }
.q-input:focus { border-color: #6366f1; box-shadow: 0 0 0 3px rgba(99,102,241,0.12); background: #fff; }
.q-input--error { border-color: #f87171 !important; }
.q-error-msg { font-size: 0.7rem; color: #ef4444; margin: 0; }
.q-check-row { display: flex; align-items: center; gap: 6px; }
.q-check-row input[type=checkbox] { width: 14px; height: 14px; accent-color: #6366f1; cursor: pointer; }
.q-check-row span { font-size: 0.72rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.06em; color: #475569; }
.q-options-header { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.q-add-btn { display: inline-flex; align-items: center; gap: 4px; padding: 4px 10px; border: 1px solid #e2e8f0; border-radius: 6px; background: #f1f5f9; color: #475569; font-size: 0.72rem; font-weight: 600; cursor: pointer; transition: all 0.15s; }
.q-add-btn:hover { background: #e2e8f0; }
.q-add-btn svg { width: 12px; height: 12px; }
.q-options-list { display: flex; flex-direction: column; gap: 5px; }
.q-option-row { display: flex; align-items: center; gap: 6px; }
.q-option-prefix { font-size: 0.72rem; color: #94a3b8; min-width: 18px; text-align: right; flex-shrink: 0; }
.q-remove-btn { display: flex; align-items: center; justify-content: center; width: 22px; height: 22px; border: 1px solid #fca5a5; border-radius: 5px; background: #fef2f2; color: #ef4444; cursor: pointer; flex-shrink: 0; transition: all 0.15s; }
.q-remove-btn:hover { background: #fee2e2; }
.q-remove-btn svg { width: 12px; height: 12px; }
.q-input--select { width: auto; min-width: 120px; max-width: 200px; }
.q-otro-type-row { display: flex; flex-direction: column; gap: 4px; margin-left: 20px; margin-top: -4px; }
.q-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(140px, 1fr)); gap: 6px; }
</style>

